<div class="w-full max-w-7xl items-center">
  <section class="mb-8 flex lg:mb-0">
    <div
      class="w-full max-w-xl rounded-xl bg-white p-8 text-black shadow-lg md:p-10"
    >
      <!-- Comcast Business | Nitel Logo -->
      <div class="mb-4 flex md:justify-center">
        <a routerLink="/" class="inline-block" title="Go to homepage">
          <img
            src="assets/images/logos/CB_Logo_Color_RGB.svg"
            alt="Comcast Business"
            class="h-10 w-auto md:h-14"
          />
        </a>
      </div>

      @if (!hasError()) {
        <h2 class="mt-4 font-montserrat text-2xl font-bold text-black">
          You are about to impersonate...
        </h2>
        <div class="mt-4 flex justify-center">
          <mat-spinner [diameter]="75"></mat-spinner>
        </div>
      } @else {
        <p class="text-lg">
          You are not authorized to impersonate. Please go through the proper
          channels to impersonate a user.
        </p>
      }
    </div>
  </section>
</div>
